import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { earlyCheckInFilterOptions } from '@new/__global/constants/filter'
import { BookingEarlyCheckInStatus } from '@new/__global/types/booking.types'

interface EarlyCheckInStatusFilterProps extends FiltersSharedProps {
  initialValue?: BookingEarlyCheckInStatus[]
  onChange: (value?: BookingEarlyCheckInStatus[]) => void
  title: string
}

export const EarlyCheckInStatusFilter: FC<EarlyCheckInStatusFilterProps> = props => {
  return <CheckboxBasedFilter options={earlyCheckInFilterOptions} {...props} />
}
